import {ReviewGenqlSelection} from "@/gql/gen";

export const ReviewFields: ReviewGenqlSelection = {
    "ID": true,
    "NAME": true,
    "DETAIL_TEXT": true,
    "ACTIVE_FROM": true,
    "PROPERTIES": {
        "AUTHOR_NAME": true,
        "ANSWER": true,
        "RATING": true,
    },
}
